module.exports = __webpack_public_path__ + "static/img/example0.605eb69.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/example0.jpg
// module id = PK8P
// module chunks = 128